import { render, staticRenderFns } from "./PriceExtraInfo.vue?vue&type=template&id=434165c7&scoped=true&"
import script from "./PriceExtraInfo.vue?vue&type=script&lang=js&"
export * from "./PriceExtraInfo.vue?vue&type=script&lang=js&"
import style0 from "./PriceExtraInfo.vue?vue&type=style&index=0&id=434165c7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "434165c7",
  null
  
)

export default component.exports